/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/
import * as escrowDatastoreCollections from '@escrow/datastore/collections';
import * as escrowDocumentCreators from '@escrow/datastore/collections-testing/document-creators';
import * as escrowPushTransformers from '@escrow/datastore/collections-testing/push-transformers';

export const datastoreFunctions = {
  customerWebhooksReducer: escrowDatastoreCollections.customerWebhooksReducer,
  createDisbursementMethods:
    escrowDatastoreCollections.createDisbursementMethods,
  createCustomerWebhook: escrowDocumentCreators.createCustomerWebhook,
  createCustomer: escrowDocumentCreators.createCustomer,
  addPushTransformers: escrowPushTransformers.addPushTransformers,
  addCustomerWebhookComputedFields:
    escrowPushTransformers.addCustomerWebhookComputedFields,
};
